import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { CrudBqResponse } from './types';

export const auditLogEndpoint = {
  server: defaultServer,
  path: 'crud/auditLog',
  description: 'Audit log operations',
};

const endpointAuditLogExec =
  getExecEndpoint<AuditLogEndpointDef>(auditLogEndpoint);

export const endpointAuditLogGET = async (filterBy: {
  entity: 'fund' | 'portfolioCompany';
  entityUuid: string;
}) => {
  const urlExtra =
    filterBy.entity === 'fund'
      ? `?fundId=${filterBy.entityUuid}`
      : `?portfolioCompanyId=${filterBy.entityUuid}`;

  const response = await endpointAuditLogExec<'GET'>({
    method: 'GET',
    urlExtra: urlExtra,
  });

  if (!response || !response.data) {
    throw new Error('Could not get audit log');
  }

  if (response.success === 0) {
    throw new Error('Could not get audit log');
  }

  return response.data;
};

export interface AuditLogEndpointDef {
  endpoint: typeof auditLogEndpoint;
  methods: {
    GET: {
      response: AuditLogGetDataResponse;
    };
    POST: {
      response: AuditLogPostResponse;
      payload: Omit<AuditLogPostPayload, 'id'>;
    };
    PATCH: {
      response: AuditLogPostResponse;
      payload: AuditLogPostPayload;
    };
  };
}

export type AuditLogPostResponse = CrudBqResponse<{ data: { id: string } }>;

export type AuditLogGetDataResponse = CrudBqResponse<AuditLogGetData[]>;

export type AuditLogPostPayload = Omit<
  AuditLogGetData,
  'id' | 'createdAt' | 'updatedAt'
>;

export type AuditLogGetData = {
  id: string;
  createdBy: string;
  userDetails: {
    fullName?: string;
  };
  companyId: string;
  portfolioCompanyId: string | null;
  fundId: string | null;
  changes: {
    [key: string]: string | number;
  };
  createdAt: string;
  updatedAt: string;
};
